import { getAppInfoApi, getAppMenuApi, getBaseDataApi,
        getPersonDataApi, getGroupUserSelectTabTree, getGroupClassSelectTabTree, groupUserSearch,
        doLogout,getStudentList, getDepartments,getOrganizationPersonList,
        getBuildingsSelector, getEnum, getMatrixData,
        getLoginUserInfo, getTopMsgNumber, getTopUnReadNotice,
        getTopUnReadMessage, getTopUnReadTodo,
        markNoticeRead, getNoticeDetail,
        markReadTodo, markAllReadTodo, deleteTodo, finishTodo,
        markReadMessage, markAllReadMessage, deleteMessage, getSpaceLiveUrl,
        getRoomLiveDetails, getUrl  } from "./app.api";
import MenuItem from '../models/menuItem'
import Tenant from '../models/tenant'
import User from '../models/user'
import App from '../models/app'
import FunctionItem from "../models/functionItem";
import KeyValue from '../models/keyValue'
import Person from "../user-select/models/person";
import Organization from "../group-user-select/models/organization";
import OrganizationOfClass from '../group-class-select/model/organization'

import CommonTree from "../models/commonTree";
import PersonItem from "../group-user-select/models/personItem";
import CommonUser from "../models/commonUser";

import SpaceLiveClientUrl from '../../components/leco/models/spaceLiveClientUrl'
// import NoticeDetails from '../model/noticeDetails'
// import NoticeItem from './notice/model/noticeItem'
// import MessageDetails from './notice/model/messageDetails'
// import TodoDetails from './notice/model/todoDetails'
// 学习生态
import RoomLiveDto from '../models/leco/roomLive/roomLiveDto'
export default class AppService {
  deserialization = ({ subFunctionItems, ...other }: any) => {
    subFunctionItems = subFunctionItems ? subFunctionItems : [];
    let subFunctionItemList: FunctionItem[] = subFunctionItems.length
      ? subFunctionItems.map(
          (functionItem: any) => new FunctionItem(functionItem)
        )
      : [];
    return new FunctionItem({
      ...other,
      subFunctionItems: subFunctionItemList,
    });
  };
  getAppInfo = async ({
    appName = "",
    leftMenuApi = "",
    topBarUrl = "",
    enumUrl = "",
  }): Promise<App> => {
    let { data: appInfo } = await getAppInfoApi(topBarUrl);
        let {data:d}=await getAppMenuApi({ appName, leftMenuApi });
        let functionItems=[];
        let entryRegedit=[];
        if(d.length){
          functionItems=d
        }else{
          functionItems=d.leftMenus
          entryRegedit=d.entryRegedit
        }
        let { data } = await getLoginUserInfo()
        let {data: enumData} = enumUrl && await getEnum(enumUrl);
        let { menuItems, tenant } = appInfo
        let menuItemList = menuItems.map((menuItem: any) => new MenuItem(menuItem))
        let functionItemList = functionItems.map((functionItem: any) => this.deserialization(functionItem))
        tenant = new Tenant(tenant);
        let user = new User(data);
        return new App({ menuItems: menuItemList, tenant, user, functionItems: functionItemList, enumData,entryRegedit });
  };
  getBaseData = async (): Promise<CommonTree[]> => {
    let { data } = await getBaseDataApi();
    return data;
  };
  getPersonData = async ({ url, searchText, userType, params = {} }): Promise<Person[]> => {
    let { data } = await getPersonDataApi({ url, searchText, userType, params });
    let personList = data.map((person) => new Person(person));
    return personList;
  };
  getCommonUserData = async ({ url, searchText, userType, params = {} }): Promise<CommonUser[]> => {
    let { data } = await getPersonDataApi({ url, searchText, userType, params });
    let commonUserList = data.map((user) => new CommonUser(user));
    return commonUserList;
  };
  // 退出登录
  doLogout = async (token): Promise<any> => {
    let { data } = await doLogout(token);
    return data;
  };
  private getOrganizationList = (data, alist?) => {
    let list = alist || [];
    for (let item of data) {
      list.push(item);
      if (item.subItems && item.subItems.length) {
        list = this.getOrganizationList(item.subItems, list);
      }
    }
    return list;
  };
  private getOrganizationNested = (data) => {
    return data.map((item) => {
      let organization = new Organization(item);
      if (item.subItems && item.subItems.length) {
        let subItems = this.getOrganizationNested(item.subItems);
        organization.subItems = subItems;
        return organization;
      }
      return new Organization(organization);
    });
  };
  getGroupUserSelectTabTree = async ({selectType, orgUrl = ''}): Promise<{
    organizationNested: Organization[];
    organizationList: Organization[];
  }> => {
    let { data } = await getGroupUserSelectTabTree({ selectType, orgUrl });
    let organizationNested = this.getOrganizationNested(data);
    let organizationList = this.getOrganizationList(organizationNested);
    return { organizationNested, organizationList };
  };
  private getOrganizationOfClassNested = (data) => {
    return data.map((item) => {
      let organization = new OrganizationOfClass(item);
      if (item.subItems && item.subItems.length) {
        let subItems = this.getOrganizationOfClassNested(item.subItems);
        organization.subItems = subItems;
        return organization;
      }
      return new OrganizationOfClass(organization);
    });
  };
  getGroupClassSelectTabTree = async (url: string, params:any): Promise<{organizationNested: OrganizationOfClass[];organizationList: OrganizationOfClass[]}> => {
    let { data } = await getGroupClassSelectTabTree(url, params);
    let organizationNested = this.getOrganizationOfClassNested(data);
    let organizationList = this.getOrganizationList(organizationNested);
    return { organizationNested, organizationList };
  }
  async getStudentListSevice(): Promise<any> {
      let {data} = await getStudentList();
      return data;
  }
  // 复杂选人框 搜索
  async groupUserSearch({searchText, userType}): Promise<any> {
    let {data} = await groupUserSearch({searchText, userType});
    return data;
  }
  // 获取部门列表
  getDepartmentList = async (categorys): Promise<CommonTree[]> => {
      let { data } = await getDepartments(categorys);
      let departmentList= data.map(department=>new CommonTree(department))
      return departmentList;
  }
  getOrganizationPersonList=async ({organizationId,selectType,organizationType, personUrl = ''}):Promise<PersonItem[]>  => {
      let { data } = await getOrganizationPersonList({organizationId,selectType,organizationType, personUrl});
      let personItemList= data.map(personItem=>new PersonItem(personItem))
      return personItemList
  }
  // 楼宇级联下拉
  async getBuildingsSelector(): Promise<CommonTree[]> {
      let {data} = await getBuildingsSelector();
      let buildingSelect = data.map(buildingSelectItem => new CommonTree(buildingSelectItem))
      return buildingSelect;
  }
  // head
  // 功能矩阵matrix
  async getMatrixData(): Promise<any> {
      let {data} = await getMatrixData();
      return data;
  }
  // 获得未读消息总数
  getTopMsgNumber = async (): Promise<KeyValue[]> => {
      let { data } = await getTopMsgNumber();
      let msgList= data.map(item=>new KeyValue(item))
      return msgList;
  }
  // 获取直播链接
  getSpaceLiveUrl = async ({url, classId}): Promise<SpaceLiveClientUrl> => {
    let { data } = await getSpaceLiveUrl({url, classId});
    return new SpaceLiveClientUrl(data)
  }
  // 负责选人框搜索
  searchPersons = async ({ url, searchText, userType, params = {} }): Promise<any[]> => {
    let { data } = await getPersonDataApi({ url, searchText, userType, params });
    return data;
  };
  // 学习生态
  // 教室直播
  // 获取教室直播详情 
  async getRoomLiveDetails(id: string):Promise<RoomLiveDto>{
      let {data} = await getRoomLiveDetails(id)
      return new RoomLiveDto(data)
  }
  // getUrl
  async getUrl({url, roomLiveId, roomNo, cameraNo}):Promise<string>{
    let {data} = await getUrl({url, roomLiveId, roomNo, cameraNo})
    return data
  }
}
